.container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.historicalBanner {
  background: #eef1f4;
  border: 1px solid var(--gray-border);
  color: var(--gray-text);
  border-radius: var(--radius);
  padding: 8px 12px;
  font-size: 12.5px;
}

.groupHeading {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--gray-text);
  padding: 10px 0 6px;
  border-bottom: 1px solid var(--gray-border);
}

.checks {
  background: var(--white);
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  padding: 0 12px;
}

.checksHeader {
  display: flex;
  align-items: center;
  /* Overall status word sits left; History select floats top-right. */
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid var(--gray-border);
}

.overallStatus {
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
}

.overallLabel {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--gray-text);
}

.overallStatusWord {
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: var(--text);
}

.overallPass {
  color: var(--green);
}

.overallWarn {
  color: var(--yellow);
}

.overallFail {
  color: var(--red);
}

.overallError {
  color: var(--orange);
}

